import React, { useState } from 'react';

function TestUploadPage() {
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const testUpload = async () => {
    setResult(null);
    setError(null);
    
    try {
      // First test the test endpoint
      const testResponse = await fetch('/api/test-upload', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ test: true })
      });
      
      const testData = await testResponse.json();
      console.log('Test endpoint response:', testData);
      
      // Create a small test file
      const testFile = new Blob(['Hello, this is a test file'], { type: 'text/plain' });
      const file = new File([testFile], 'test.txt', { type: 'text/plain' });
      
      // Try the simple upload first
      const simpleResponse = await fetch('/api/simple-upload', {
        method: 'POST',
        body: file,
      });
      
      const simpleData = await simpleResponse.json();
      console.log('Simple upload response:', simpleData);
      
      // Try the actual upload
      const uploadResponse = await fetch(`/api/upload?filename=${encodeURIComponent(file.name)}`, {
        method: 'POST',
        body: file,
      });
      
      const uploadData = await uploadResponse.json();
      console.log('Upload response:', uploadData);
      
      setResult({
        test: testData,
        simple: simpleData,
        upload: uploadData,
        status: uploadResponse.status
      });
    } catch (err) {
      console.error('Test error:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-8">
      <h1 className="text-2xl font-bold mb-4">Upload Test Page</h1>
      
      <button
        onClick={testUpload}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Test Upload
      </button>
      
      {error && (
        <div className="mt-4 p-4 bg-red-100 text-red-700 rounded">
          Error: {error}
        </div>
      )}
      
      {result && (
        <div className="mt-4 p-4 bg-gray-100 rounded">
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}

export default TestUploadPage;